import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { logoutUser } from "slices/thunk";

//redux
import { useSelector, useDispatch } from "react-redux";
import withRouter from "Common/withRouter";
import { createSelector } from "reselect";

const Logout = () => {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();

  const selectLogin = createSelector(
    (state: any) => state.Login,
    (login) => ({
      isUserLogout: login.isUserLogout,
    })
  );

  const { isUserLogout } = useSelector(selectLogin);

  useEffect(() => {
    // Dispatch logout action
    dispatch(logoutUser());
  }, [dispatch]);

  useEffect(() => {
    // Navigate to login page after logout is complete
    if (isUserLogout) {
      navigate("/login");
    }
  }, [isUserLogout, navigate]);

  // Show loading or empty fragment while logout is processing
  return <React.Fragment></React.Fragment>;
};

export default withRouter(Logout);